import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'gl-register-page',
    templateUrl: './seutulippu-register-page.component.html'
})
export class SeutulippuRegisterPageComponent {
    flowStep = 1;

    constructor(
        private translate: TranslateService,
        private router: Router
    ) {}

    onBack() {
        this.router.navigate([this.translate.currentLang, 'account', 'seutulippu']);
    }

    handleSaveSuccess() {
        this.flowStep = 2;
    }
}
